export default __webpack_public_path__ + "static/media/img-slider-finedae-3.a7b40f22.png";